"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timestamp = void 0;
const tslib_1 = require("tslib");
const moment_1 = tslib_1.__importDefault(require("moment"));
const ValueObject_1 = require("./ValueObject");
class Timestamp extends ValueObject_1.ValueObject {
    constructor(value) {
        super(value);
    }
    toDate() {
        return new Date(this.value);
    }
    toMoment() {
        return moment_1.default(this.value);
    }
    toString() {
        return this.value ? this.toDate().toLocaleString() : "";
    }
    get localeString() {
        return this.toDate().toLocaleString();
    }
    static create(value) {
        return new Timestamp(value);
    }
}
exports.Timestamp = Timestamp;
//# sourceMappingURL=Timestamp.js.map